import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0057B8",
      "fill-rule": "evenodd",
      stroke: "#0057B8",
      "stroke-width": ".25",
      d: "M10.882 1.043a8.93 8.93 0 0 1 5.47 2.596 9.02 9.02 0 0 1 2.637 5.925 9 9 0 0 1-2.036 6.15 8.96 8.96 0 0 1-5.188 3.11c-2.045.409-4.17.1-6.009-.873a9.05 9.05 0 0 1-4.071-4.5 9.03 9.03 0 0 1-.3-6.057 9 9 0 0 1 3.614-4.873 8.98 8.98 0 0 1 5.883-1.478Zm.616 16.522a7.72 7.72 0 0 0 4.45-2.662 7.73 7.73 0 0 0 1.74-5.28 7.75 7.75 0 0 0-2.262-5.084 7.682 7.682 0 0 0-9.696-.951 7.8 7.8 0 0 0-2.6 2.96 7.7 7.7 0 0 0 .373 7.573 7.86 7.86 0 0 0 2.88 2.698 7.67 7.67 0 0 0 5.115.746ZM9.325 7.433h1.632V6.147H9.325zm1.632 1.285v5.144H9.325V8.718z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }